// @ts-nocheck

import { isAclDataRestrictionsReadWriteEnabled, isAclRolesReadWriteEnabled, isAclUsersReadWriteEnabled } from 'models/user/selector';
// @ts-nocheck
import { initialState } from './reducer';
const settingsSelector = state => state.settings || initialState;

export const getDashBoardData = state => {
    return settingsSelector(state)['dashBoardData'];
};

export const isLoading = (state, attr) => settingsSelector(state).isLoading[attr];

export const getEnabledOptions = (state) => {
    return [
        {
            title: 'App Column Aliases',
            description: 'Create or edit App Column Aliases',
            buttonText: 'View',
            url: '/settings/columnaliases',
            count: getDashBoardData(state)?.aliasCount ?? "0",
            isEnabled: true,
        },
        {
            title: 'User Roles',
            description: 'User Roles',
            buttonText: 'View',
            isEnabled: isAclRolesReadWriteEnabled(state),
            count: getDashBoardData(state)?.roleCount ?? "0",
            url: '/settings/roles'
        },
        {
            title: 'App Users',
            description: 'App Users',
            buttonText: 'View',
            isEnabled: isAclUsersReadWriteEnabled(state),
            count: getDashBoardData(state)?.userCount ?? "0",
            url: '/settings/users'
		
        },
        {
            title: 'App Data Restrictions',
            description: 'App Data Restrictions',
            buttonText: 'View',
            isEnabled: isAclDataRestrictionsReadWriteEnabled(state),
            count: getDashBoardData(state)?.appDataRestriction ?? "0",
            url: '/settings/restrictions'
        }
    ].filter(x => x.isEnabled)
};
